import * as React from 'react';
import { iconName } from '../icons/Icons';
import { Button } from '../button/Button';
import { Flex } from './FlexHelpers';
import { ButtonVariant } from '../button/Shared';


export type ToolBarButtonProps = {
    disabled?: boolean,
    icon:iconName,
    onClick?:() => void,
    tooltip:string,
    variant?: ButtonVariant

}

export function ToolBarButton(props:ToolBarButtonProps):JSX.Element
{
    return (
        <Button 
            icon={props.icon} 
            variant={props.variant} 
            toolTipText={props.tooltip} 
            onClick={props.onClick} 
            disabled={props.disabled} />
    );
}

type ToolBarContainerProps = {
    children:React.ReactNode
}

export function ToolBarContainer(props:ToolBarContainerProps):JSX.Element
{
    return (
        <Flex flexDirection="row" alignItems='center'>
            {props.children}
        </Flex>
    );
}